import { useEffect } from 'react';

const useModalFlow = (deviceType, isFlow) => {
  useEffect(() => {
    if (!isFlow) return;

    const content = document.querySelector('.andes-modal.layout.layout--default');
    const contentHeight = content ? Math.min(content.scrollHeight, content.offsetHeight) : null;

    window.parent.postMessage(
      {
        type: 'nav:cp:loaded',
        height: contentHeight ? `${contentHeight}px` : '100%',
        deviceType,
      },
      '*',
    );
  }, [deviceType, isFlow]);
};

export default useModalFlow;
